import { useFormikContext } from 'formik';
import { useDeepCompareEffect } from '@/hooks/utils/useDeepCompareEffect';

export function FormikObserver({ onChange = () => null }: any) {
  const { values } = useFormikContext();

  useDeepCompareEffect(() => {
    onChange(values);
  }, [values]);

  return null;
}
